import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgTypography } from "@intelligems/ig-theme";
import { AnyProgressBarWidget } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { ShippingProgressBarTextReplacements } from "../../../features/personalizations/components/offerModifications/userInterfaces/TextReplacements";
import {
  initializeProgressBarVariableSettings,
  selectedWidget,
} from "../../../store/slices/widgets";

interface ProgressBarWidgetVariableSettingsProps {
  configType: "desktop" | "mobile";
}

export const ShippingProgressBarWidgetVariableSettings = ({
  configType,
}: ProgressBarWidgetVariableSettingsProps) => {
  const progressBarWidget = useSelector(selectedWidget) as AnyProgressBarWidget;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(initializeProgressBarVariableSettings({ configType }));
  }, [configType]);

  if (progressBarWidget.config[configType]?.variables?.textReplacements) {
    return (
      <Grid container item direction={"column"} rowGap={2}>
        <Grid item>
          <IgTypography sx={{ fontWeight: 600, fontSize: "16px" }}>
            Text Options
          </IgTypography>
        </Grid>
        <Grid item>
          <ShippingProgressBarTextReplacements
            configType={configType}
            widget={progressBarWidget}
            templateKey={"buyMoreTemplate"}
            headerTitle={"Under Threshold Text"}
          />
        </Grid>
        <Grid item>
          <ShippingProgressBarTextReplacements
            configType={configType}
            widget={progressBarWidget}
            templateKey={"allTiersUnlockedTemplate"}
            headerTitle={"Over Threshold Text"}
          />
        </Grid>
      </Grid>
    );
  }

  return null;
};
